import { jsxs as b, jsx as p } from "react/jsx-runtime";
import l, { forwardRef as d } from "react";
import _ from "../../icons/Tiktok.js";
import j from "../../icons/Twitter.js";
import { classes as f } from "../../utils/helpers.js";
import { ImageReplacementAnchor as x } from "../ImageReplacementAnchor/ImageReplacementAnchor.js";
import { F as z } from "../../facebook-D2izPFQS.mjs";
import { P as a } from "../../index-CZzwT3Oj.mjs";
import '../../assets/SocialLinks.css';function m() {
  return m = Object.assign || function(e) {
    for (var i = 1; i < arguments.length; i++) {
      var n = arguments[i];
      for (var t in n)
        Object.prototype.hasOwnProperty.call(n, t) && (e[t] = n[t]);
    }
    return e;
  }, m.apply(this, arguments);
}
function E(e, i) {
  if (e == null) return {};
  var n = P(e, i), t, o;
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    for (o = 0; o < r.length; o++)
      t = r[o], !(i.indexOf(t) >= 0) && Object.prototype.propertyIsEnumerable.call(e, t) && (n[t] = e[t]);
  }
  return n;
}
function P(e, i) {
  if (e == null) return {};
  var n = {}, t = Object.keys(e), o, r;
  for (r = 0; r < t.length; r++)
    o = t[r], !(i.indexOf(o) >= 0) && (n[o] = e[o]);
  return n;
}
var k = d(function(e, i) {
  var n = e.color, t = n === void 0 ? "currentColor" : n, o = e.size, r = o === void 0 ? 24 : o, c = E(e, ["color", "size"]);
  return /* @__PURE__ */ l.createElement("svg", m({
    ref: i,
    xmlns: "http://www.w3.org/2000/svg",
    width: r,
    height: r,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, c), /* @__PURE__ */ l.createElement("rect", {
    x: "2",
    y: "2",
    width: "20",
    height: "20",
    rx: "5",
    ry: "5"
  }), /* @__PURE__ */ l.createElement("path", {
    d: "M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"
  }), /* @__PURE__ */ l.createElement("line", {
    x1: "17.5",
    y1: "6.5",
    x2: "17.51",
    y2: "6.5"
  }));
});
k.propTypes = {
  color: a.string,
  size: a.oneOfType([a.string, a.number])
};
k.displayName = "Instagram";
function g() {
  return g = Object.assign || function(e) {
    for (var i = 1; i < arguments.length; i++) {
      var n = arguments[i];
      for (var t in n)
        Object.prototype.hasOwnProperty.call(n, t) && (e[t] = n[t]);
    }
    return e;
  }, g.apply(this, arguments);
}
function $(e, i) {
  if (e == null) return {};
  var n = L(e, i), t, o;
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    for (o = 0; o < r.length; o++)
      t = r[o], !(i.indexOf(t) >= 0) && Object.prototype.propertyIsEnumerable.call(e, t) && (n[t] = e[t]);
  }
  return n;
}
function L(e, i) {
  if (e == null) return {};
  var n = {}, t = Object.keys(e), o, r;
  for (r = 0; r < t.length; r++)
    o = t[r], !(i.indexOf(o) >= 0) && (n[o] = e[o]);
  return n;
}
var y = d(function(e, i) {
  var n = e.color, t = n === void 0 ? "currentColor" : n, o = e.size, r = o === void 0 ? 24 : o, c = $(e, ["color", "size"]);
  return /* @__PURE__ */ l.createElement("svg", g({
    ref: i,
    xmlns: "http://www.w3.org/2000/svg",
    width: r,
    height: r,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, c), /* @__PURE__ */ l.createElement("path", {
    d: "M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"
  }), /* @__PURE__ */ l.createElement("rect", {
    x: "2",
    y: "9",
    width: "4",
    height: "12"
  }), /* @__PURE__ */ l.createElement("circle", {
    cx: "4",
    cy: "4",
    r: "2"
  }));
});
y.propTypes = {
  color: a.string,
  size: a.oneOfType([a.string, a.number])
};
y.displayName = "Linkedin";
function h() {
  return h = Object.assign || function(e) {
    for (var i = 1; i < arguments.length; i++) {
      var n = arguments[i];
      for (var t in n)
        Object.prototype.hasOwnProperty.call(n, t) && (e[t] = n[t]);
    }
    return e;
  }, h.apply(this, arguments);
}
function W(e, i) {
  if (e == null) return {};
  var n = T(e, i), t, o;
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    for (o = 0; o < r.length; o++)
      t = r[o], !(i.indexOf(t) >= 0) && Object.prototype.propertyIsEnumerable.call(e, t) && (n[t] = e[t]);
  }
  return n;
}
function T(e, i) {
  if (e == null) return {};
  var n = {}, t = Object.keys(e), o, r;
  for (r = 0; r < t.length; r++)
    o = t[r], !(i.indexOf(o) >= 0) && (n[o] = e[o]);
  return n;
}
var v = d(function(e, i) {
  var n = e.color, t = n === void 0 ? "currentColor" : n, o = e.size, r = o === void 0 ? 24 : o, c = W(e, ["color", "size"]);
  return /* @__PURE__ */ l.createElement("svg", h({
    ref: i,
    xmlns: "http://www.w3.org/2000/svg",
    width: r,
    height: r,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, c), /* @__PURE__ */ l.createElement("path", {
    d: "M22.54 6.42a2.78 2.78 0 0 0-1.94-2C18.88 4 12 4 12 4s-6.88 0-8.6.46a2.78 2.78 0 0 0-1.94 2A29 29 0 0 0 1 11.75a29 29 0 0 0 .46 5.33A2.78 2.78 0 0 0 3.4 19c1.72.46 8.6.46 8.6.46s6.88 0 8.6-.46a2.78 2.78 0 0 0 1.94-2 29 29 0 0 0 .46-5.25 29 29 0 0 0-.46-5.33z"
  }), /* @__PURE__ */ l.createElement("polygon", {
    points: "9.75 15.02 15.5 11.75 9.75 8.48 9.75 15.02"
  }));
});
v.propTypes = {
  color: a.string,
  size: a.oneOfType([a.string, a.number])
};
v.displayName = "Youtube";
const u = {
  "social-link": "_social-link_1pbud_1",
  "social-link__icon": "_social-link__icon_1pbud_12"
}, C = /* @__PURE__ */ new Map([
  ["facebook", z],
  ["instagram", k],
  ["linkedin", y],
  ["youtube", v],
  ["tiktok", _],
  ["twitter", j]
]);
function Y({
  onClickHandler: e = () => !0,
  size: i = 1.4,
  showHeader: n = !1,
  headerText: t = "Follow Us",
  platforms: o = [
    {
      platform: "facebook",
      url: "https://www.facebook.com/EWScrippsCo"
    },
    {
      platform: "twitter",
      url: "https://twitter.com/EWScrippsCo"
    },
    {
      platform: "instagram",
      url: "https://www.instagram.com/EWScrippsCo"
    },
    {
      platform: "linkedin",
      url: "https://www.linkedin.com/company/the-e-w-scripps-company"
    }
  ]
}) {
  return /* @__PURE__ */ b("div", { className: f([u["social-links"], "social-links"]), children: [
    n && /* @__PURE__ */ p("h4", { className: f([
      u["social-links__header"],
      "social-links__header"
    ]), children: t }),
    o.map((r, c) => {
      const { platform: s, url: w } = r, O = r != null && r.image ? r.image : C.get(s);
      return r != null && r.image ? /* @__PURE__ */ p(
        x,
        {
          image: r.image,
          text: s,
          target: "_blank",
          href: w,
          height: i,
          classname: f([u["social-link"], "social-link", `social-link--${s}`])
        },
        `social-link-${s}`
      ) : /* @__PURE__ */ p(
        "a",
        {
          href: w,
          className: f([u["social-link"], "social-link", `social-link--${s}`]),
          onClick: e,
          target: "_blank",
          rel: "noreferrer",
          children: /* @__PURE__ */ b("i", { children: [
            /* @__PURE__ */ p("span", { className: "sr-only", children: s }),
            /* @__PURE__ */ p(
              O,
              {
                className: f([u["social-link__icon"], "social-link__icon"]),
                size: `${i}rem`,
                ...r.svgAttrs
              }
            )
          ] })
        },
        `social-link-${s}`
      );
    })
  ] });
}
export {
  Y as SocialLinks,
  Y as default
};
